import { render, staticRenderFns } from "./modal-fields.vue?vue&type=template&id=df1e2b90&scoped=true&"
import script from "./modal-fields.vue?vue&type=script&lang=js&"
export * from "./modal-fields.vue?vue&type=script&lang=js&"
import style0 from "./modal-fields.vue?vue&type=style&index=0&id=df1e2b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e2b90",
  null
  
)

export default component.exports